module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAIZJREFUOBFjYBgF0BBgJDUkKisrt/7//98LWR8jI+O29vZ2b2QxJmQOMWx0Q0F6sImRbDAxloPU0MxgFnQXEBuG6PrQ+RguxhZe2MTQDULnYxiMroBc/qjB8JAbBkEByvdw/yAYW2FMQvIwdUOPBhebFRUVt4BOV6WS8293dHSoUcms4WAMAINgJRWJPM9vAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_ValighBottom_disabled.png
// module id = 314
// module chunks = 0